import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import { useTranslation } from "src/hooks/translation";
import { maxStakeLimitReached } from "src/rules/bet";
import selectionsStore from "src/stores/selections";
import { useConfig } from "src/hooks/config";
import mainStore from "src/stores/main";

import "./style.scss";

const SuperbetInfo = () => {
	const t = useTranslation();
	const config = useConfig();
	const { selections } = useRecoilValue(selectionsStore);
	const mainState = useRecoilValue(mainStore);

	const needToActivateSuperbet = useMemo(
		() =>
			config.enableSuperbetToggle &&
			!config.enableAutomaticSuperbet &&
			!config.superbetHiddenMode &&
			maxStakeLimitReached(config, selections, mainState),
		[config, selections, mainState]
	);

	if (needToActivateSuperbet)
		return (
			<div className={"B-info B-superbet-info"}>
				<div className="B-betslip-notif-icon">
					<i className="global-icon icon-filled-info" />
				</div>
				<div className="B-betslip-notif-txt">
					<p className="B-betslip-notif-txt-superbit">
						{t("Please activate SUPERBET mode")}
					</p>
					<p className="B-betslip-notif-txt-amount">
						{t(`Input higher than {1} allowed`, mainState.maxStake.toString())}
					</p>
				</div>
			</div>
		);

	return mainState.isSuperbet && !config.superbetHiddenMode ? (
		<div className={"B-info B-superbet-info"}>
			<div className="B-betslip-notif-icon">
				<i className="global-icon icon-filled-info" />
			</div>
			<div className="B-betslip-notif-txt">
				<p className="B-betslip-notif-txt-superbit">
					{t(
						"SuperBet allows to request to trader for placing a bet with higher amount than max bet limit."
					)}
				</p>
				<p className="B-betslip-notif-txt-amount">
					{t("Input higher than")} {mainState.maxStake}
				</p>
			</div>
		</div>
	) : null;
};

export default SuperbetInfo;
